import { isNullOrUndefined } from '@utils/utils';

/**
 * Drops filter keys that hold no user-meaningful value before the filter reaches the API.
 *
 * Clearing a filter does not delete its key — the chip controls reset it to an empty value
 * (Dropdown → null, InputText → '', MultiSelect → []). Those keys still get serialized into the
 * query string (`?supplierLocationCountry=`), which the backend reads as "match the empty value"
 * rather than "no filter at all". Removing them keeps a cleared filter equivalent to a never-set one.
 *
 * `false` is a real value (unchecked Checkbox filters) and is kept.
 */
export const withoutEmptyValues = <TFilter,>(filter: TFilter): TFilter => {
  if (!filter || typeof filter !== 'object') return filter;
  return Object.fromEntries(
    Object.entries(filter).filter(([, value]) => !isNullOrUndefined(value) && value !== '' && !(Array.isArray(value) && value.length === 0)),
  ) as TFilter;
};
